import React from "react";
import { useFormik } from "formik";
import { DebitCreditAddFormValidation } from "./DebitCreditAddFormValidation";
import DebitCreditAddFormFields from "./DebitCreditAddFormFields";
import { ErrorToast, SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import { client } from "../../../service/ApolloClient/ApolloClient";
import errorValidationApollo from "../../../utility/Forms/errorValidationApollo";
import { Box, Button, ButtonGroup, Card, CardContent, Typography } from "@material-ui/core";
import {
  MUTATION_ADD_DEBIT_CREDIT,
  MUTATION_EDIT_DEBIT_CREDIT,
} from "../../../service/ApolloClient/ApolloMutation";
import { withRouter } from "react-router";
import checkDateInput from "../../../utility/CheckDateInput/checkDateInput";
import { generateDebitCreditPdf } from "../../../utility/PdfGenerator/DebitCreditPdfGenerator";
import PrintIcon from "@material-ui/icons/Print";

const validationSchema = DebitCreditAddFormValidation;

const DebitCreditAddForm = (props) => {
  const { data } = props;

  let valuesDefault = {
    cleared_at: null,
    date: null,
    amount: null,
    remained: 0,
    user_id: "",
    status: "",
    type: "",
    about: "",
    description: "",
  };

  if (props.isEdit) {
    valuesDefault = {
      ...valuesDefault,
      ...data,
    };
  } else if (props.user) {
    valuesDefault = {
      ...valuesDefault,
      user_id: props.user.id,
      user_fullname: props.user.fullname,
    };
  }

  const formikData = useFormik({
    initialValues: valuesDefault,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      let newValue = values;
      newValue.cleared_at = checkDateInput(values.cleared_at);
      newValue.date = checkDateInput(values.date);

      submitHandle(newValue);
    },
  });

  const submitHandle = (values) => {
    setLoading(true);
    values.amount = parseFloat(values.amount);
    client
      .mutate({
        mutation: props.isEdit
          ? MUTATION_EDIT_DEBIT_CREDIT
          : MUTATION_ADD_DEBIT_CREDIT,
        variables: values,
      })
      .then((result) => {
        let debtCredit = props.isEdit
          ? result.data.editDebtCredit
          : result.data.addDebtCredit;
        if (debtCredit === null) {
          ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
          formikData.setErrors(
            errorValidationApollo({ title: "قادر به ثبت نمی باشد" }),
          );
        } else {
          SuccessToast("درخواست با موفقیت انجام شد ");
        }
        setLoading(false);
        if (props.isModal) {
          props.handleClose();
        } else {
          props.history.push("/debit-credit/edit/" + debtCredit.id);
        }
      })
      .catch((reason) => {
        ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
        formikData.setErrors(errorValidationApollo(reason));
        setLoading(false);
      });

    setLoading(true);
  };

  const [loading, setLoading] = React.useState(false);

  return (
    <Box mt={2}>
      {props.isModal ? (
        <DebitCreditAddFormFields
          loading={loading}
          isEdit={props.isEdit}
          {...formikData}
        />
      ) : (
        <Card>
          <CardContent>
            <Box ml={2} mb={2} display={"flex"}>
              <Box flexGrow={1} ml={1}>
                <Typography variant={"h5"} align={"left"}>
                  {props.isEdit
                    ? "ویرایش بدهی یا طلب " + " " + props.data.id
                    : "  افزودن بدهی یا طلب"}
                </Typography>
              </Box>
              {props.isEdit ? (
                <Box style={{ textAlign: "left", float: "right" }} display={"flex"}>
                  <ButtonGroup>
                    <Button
                      color={"default"}
                      startIcon={<PrintIcon />}
                      onClick={() => generateDebitCreditPdf(props.data)}
                    >
                      پرینت
                    </Button>
                  </ButtonGroup>
                </Box>
              ) : null}
            </Box>
            <DebitCreditAddFormFields
              loading={loading}
              isEdit={props.isEdit}
              {...formikData}
            />
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default withRouter(DebitCreditAddForm);
